<template>
    <div class="header" >

      <div class="header_main">
        <p class="header-text">
      <!-- <img src="./img/logo.png" style="width: 50px;height: 50px;"/> -->
       锦州市电子保函综合服务平台

        </p>
        <div class="header_top">
          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect"  style="font-size:15px" >
          <el-menu-item index="1">首页</el-menu-item>
          <el-menu-item index="2">保函产品</el-menu-item>
          <el-menu-item index="3">助贷服务</el-menu-item>
          <el-menu-item index="4">资讯中心 </el-menu-item>
          <el-menu-item index="5">保函查验</el-menu-item>
          <el-menu-item index="6" class="login" v-if="userInfo == null">
            <span >注册/登录</span>
          </el-menu-item>
          <el-menu-item index="6" v-else style="background: white !important;color: #909399 !important; ">
            <img src="../assets/img/user.png" style="width: 32px; height: 32px;margin-right:10px;"  alt="">{{ userInfo.applicant }}
          </el-menu-item>
        </el-menu>
        </div>
        
      </div>
       
        
  </div>
</template>
<script>
import {gettoken,gettuserInfo} from '@/api/user'
import Cookies from 'js-cookie'
  import Logo from './Logo'
  import ZuiFooter from './Footer'
  import ZuiButton from './Button'
  import './less/header.less'
  import DropList from 'vue-droplist'
  export default {
    props: {
      active: {
        default: '1'
      }
    },
    watch:{
      active(newval,oldval){
        if(newval){
          this.activeIndex =newval
          localStorage.setItem('active',newval)
        }
      }
    },
    components: {Logo, ZuiFooter,ZuiButton,DropList},
    data(){
      return{
        configData : {
            position: {  // 设置显示位置，position
              top: '60px',
              right: '15px',
              bottom: '',
              left: ''
            },
            width: '40%', // 设置宽度
            list: [ // 设置下拉列表数据和对应的点击事件
              {text: '首页', action: this.gohome},
              {text: '电子保函', action: this.goservice},
              {text: '关于我们', action: this.goplan},
              {text: '资讯中心', action: this.gocase},
              {text: '帮助中心', action: this.golink},
              {text: '商务合作', action: this.plan}
            ]
        },
        activeIndex:'1',
        userInfo:null

      }
    },
    beforeMount(){
      this.activeIndex = localStorage.getItem('active') || '1'

    },
    mounted(){
      if(!localStorage.getItem('token')){
        if(Cookies.get('userId')){
          this.gettoken()
        }
      }
      if(localStorage.getItem('userInfo')){
        this.userInfo =  JSON.parse(localStorage.getItem('userInfo'))
      }else{
        this.getUserInfo()
      }
    },
    methods:{
      gettoken(){
        gettoken({
          customerToken:Cookies.get('userId')
        }).then(res=>{
          localStorage.setItem('token',res.data.accessToken)
          localStorage.setItem('refreshToken',res.data.refreshToken)
          this.getUserInfo()
        })
      },
      getUserInfo(){
        gettuserInfo().then(res=>{
          this.userInfo = res.data
          localStorage.setItem('userInfo',JSON.stringify(res.data))

        })
      },
      onButtonClick: function (e) {
        if(e=="home"){
            this.$router.push({path:'/'})
        }else if(e=="service"){
            this.$router.push({path:'/Guarantee'})
        }else if(e=="about"){
            this.$router.push({path:'/about'})
        }else if(e=="info"){
            this.$router.push({path:'/info'})
        }else if(e=="help"){
            this.$router.push({path:'/help'})
        }else if(e=="Business"){
            this.$router.push({path:'/Business'})
        }
      },
      openMenu: function () {
       this.$refs.droplist.show()
      },
      gohome: function () {
       this.$router.push({path:'/'})
      },
      goservice: function () {
       this.$router.push({path:'/Guarantee'})
      },
      goplan: function () {
       this.$router.push({path:'/about'})
      },
      gocase: function () {
       this.$router.push({path:'/info'})
      },
      golink: function () {
       this.$router.push({path:'/help'})
      },
      plan: function () {
       this.$router.push({path:'/Business'})
      },
      handleSelect(e){
        console.log(e)
        if(e=="1"){
            this.$router.push({path:'/'})
        }else if(e=="2"){
            this.$router.push({path:'/Guarantee'})
        }else if(e=="3"){
            this.$router.push({path:'/about'})
        }else if(e=="4"){
            this.$router.push({path:'/info'})
        }else if(e=="5"){
            this.$router.push({path:'/help'})
        }else if(e=="6"){
           window.open(window.SITE_CONFIG.baseUrl +  '/social-login')
        }
        this.activeIndex = e
        localStorage.setItem('active',e)
      }
    }
  }
</script>
<style scoped>

.el-menu.el-menu--horizontal{
  border-bottom: none !important;
}
/deep/ .el-submenu__title{
  font-size: 18px !important;
}
/deep/ .el-menu-item{
  font-size: 18px !important;
}
.header{
  width: 100%;
  height: 70px;
  display: flex;
  line-height: 50px;
}
.header_main{
  position: relative;
  width: 90%;
  margin: auto;
  max-width: 1200px;
}
.header_top{
  position:absolute;
  right:50px;
  top: 0px;
}
.header-text{
 
font-size: 28px;
font-weight: 500;
color: #333333 !important;
line-height: 70px;
z-index: 50;
}
/deep/ .el-menu--horizontal>.el-menu-item.is-active{
  background: #1279EB !important;
  color: white !important;
  border: none;
}
/deep/ .el-dropdown-menu__item, .el-menu-item{
  padding: 0;
  font-size: 15px !important;
  width: 78px !important;
  text-align: center;
  height: 70px !important;
  line-height: 70px !important;
  margin-right: 32px !important;
}
/* @media screen and (min-width: 376px) and (min-width:768px)  {
  .header_top {
        display: none
    }
} */
.login{
  width: 88px !important;
  height: 30px !important;
  border-radius: 100px 100px 100px 100px !important;
  opacity: 1 !important;
  border: 1px solid #1279EB !important;
  line-height: 30px !important;
  margin-top: 18px !important;
  color:#909399 ;

}

</style>


// WEBPACK FOOTER //
// src/components/Headerbox.vue